import { render, staticRenderFns } from "./BurgerComponent.vue?vue&type=template&id=57fd15db&scoped=true"
import script from "./BurgerComponent.vue?vue&type=script&lang=js"
export * from "./BurgerComponent.vue?vue&type=script&lang=js"
import style0 from "./BurgerComponent.vue?vue&type=style&index=0&id=57fd15db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd15db",
  null
  
)

export default component.exports